import styled from 'styled-components';
import { BorderColor } from 'styles/Global/colorSemantic';
import { zIndex } from 'styles/Global/globalStyles';
import { Body2Bold } from 'styles/Global/typography';
import IcMenu from 'assets/Icons/Menu/IcMenu';
import IcAccountFillOn from 'assets/Icons/Account/IcAccountFillOn';
import { useNavigate } from 'react-router-dom';
import { mindupAdminMobilePaths } from 'constants/path';

const MindUpAdminMobileUserReservationConsultationHeader = ({ onClick }: { onClick: () => void }) => {
    const navigate = useNavigate();

    return (
        <Layout>
            예약된 나의 상담
            <FlexWrapper>
                <button onClick={() => navigate(mindupAdminMobilePaths.MindUpAdminMobileAccountSetting)}>
                    <IcAccountFillOn />
                </button>
                <button onClick={onClick}>
                    <IcMenu />
                </button>
            </FlexWrapper>
        </Layout>
    );
};

export default MindUpAdminMobileUserReservationConsultationHeader;

const Layout = styled(Body2Bold)`
    position: fixed;
    top: 0;
    left: 50%; // 왼쪽에서 50% 위치로 이동
    transform: translateX(-50%);
    z-index: ${zIndex.floating + 1};
    display: flex;
    padding: 0 16px;
    align-items: center;
    justify-content: space-between;
    min-width: 360px;
    max-width: 576px;
    width: 100%;
    height: 56px;
    background-color: white;

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px; /* border-bottom의 두께 */
        background: linear-gradient(180deg, ${BorderColor.color_border_normal}, ${BorderColor.color_border_weak}, ${BorderColor.color_border_neutral});
    }
`;

const FlexWrapper = styled.div`
    display: flex;
    height: 100%;
    align-items: center;
    gap: 20px;
`;
